export default __webpack_public_path__ + "static/media/start.50a47e04.jpg";